import { Component, OnInit } from '@angular/core';
import { UserService } from '../_services/user.service';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-user-favorites',
  templateUrl: './user-favorites.component.html',
  styleUrls: ['./user-favorites.component.css']
})
export class UserFavoritesComponent implements OnInit {
  userId = this.userService.getUid();
  followPosts=[];
  constructor(private userService: UserService,
    private afs:AngularFirestore
    ) { }

  ngOnInit() {
    
    

    
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/user-favorites/user-favorites.component.ts